import { render, staticRenderFns } from "./logoAndImage.vue?vue&type=template&id=4314c132&scoped=true&"
import script from "./logoAndImage.vue?vue&type=script&lang=js&"
export * from "./logoAndImage.vue?vue&type=script&lang=js&"
import style0 from "./logoAndImage.vue?vue&type=style&index=0&id=4314c132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314c132",
  null
  
)

export default component.exports